import { Link, LinkProps, styled } from "@mui/material"

export const ExternalLink = styled(Link)<LinkProps>(() => ({
  color: "#006C9C",
  ":hover": {
    color: "#00B8D9"
  }
}));